import { Component, OnInit, ViewChild,ElementRef } from '@angular/core';
import { LeadsService } from '../../_service/leads.service';
import { SharedService } from '../../_service/shared.service';
import { MiscService } from '../../_service/misc.service';
import { ActivatedRoute, Router  } from '@angular/router';
import {PageEvent, MatPaginator} from '@angular/material/paginator';
import {MatDialog} from '@angular/material/dialog';
import {UpdateInsuranceModalComponent} from '../../insurance/update-insurance-modal/update-insurance-modal.component';
import {OpdModalComponent} from '../../opd/opd-modal/opd-modal.component';
import {IpdModalComponent} from '../../ipd/ipd-modal/ipd-modal.component';
import * as XLSX from 'xlsx';
import {formatDate} from '@angular/common';
import { NgModel } from '@angular/forms';
import { UserService } from '../../_service/user.service';
declare var $: any;
import{ GlobalConstants } from '../../common/global-constants';
const apiUrlServ = GlobalConstants.openApiURL

@Component({
  selector: 'app-leads-with-call-recording',
  templateUrl: './leads-with-call-recording.component.html',
  styleUrls: ['./leads-with-call-recording.component.css']
})
export class LeadsWithCallRecordingComponent implements OnInit {

  perpage:number=25;leads:any=[];length:number=0;pageEvent: PageEvent;loading:boolean=true;myrole:string;treatment='';userId:string;
  pageSizeOptions = [10,25,50,100,500];pageIndex:number=0;leadStatus=[];bds=[];loaded:boolean=false;circles=[];circle='';bridgeno;
  search:string;lead_source:string;lead_status:string;bd:string;start_date:string='';end_date:string='';treatments=[];leadStatus_copy=[];bds_copy=[];circles_copy=[];treatments_copy=[];treatCategory=[];
  copyData:boolean= false;LeadId;category_filter:string;payment_mode:string;lead_category_filter='';
  submitted:boolean=false;showopdDonebutIpdNotDone:string;s3url:string='';tertiary_city_filter:string;gender:string;lead_sources=[];bridge_number_lists=[];
  tertiarycityFilter:boolean=false;isCMAccess:string;start_date_follow_up:string='';end_date_follow_up:string='';c2crecording:string; showNumberArray=[];
  displayInactiveUsersLead:boolean;submittedPartners:boolean=false;partner_leads=[];start_date_dump ='';
  end_date_dump = '';dump_loading:boolean=false;dump_from_paging:number;dump_to_paging:number;dump_per_page:number;dump_total:number=0;paging_html_dump:any='';date_range_dump:string='';export_dump_with_c2c:string;export_dump_with_kalera_call:string;c2ckalerarecording:string;pre_sale_users_filter:string;allpre_sale_users = [];
  @ViewChild('dateRangeStart', {static: false}) dateRangeStart: ElementRef;
  @ViewChild('dateRangeEnd', {static: false}) dateRangeEnd: ElementRef;
  @ViewChild('followupdateRangeStart', {static: false}) followupdateRangeStart: ElementRef;
  @ViewChild('followupdateRangeEnd', {static: false}) followupdateRangeEnd: ElementRef;
  @ViewChild('csvUpload', {static: false}) csvUpload: ElementRef;
  @ViewChild('csvUploadFb', {static: false}) csvUploadFb: ElementRef;
  @ViewChild('csvUploadPartners', {static: false}) csvUploadPartners: ElementRef;
  @ViewChild(MatPaginator) paginator: MatPaginator;
  @ViewChild('dateRangeStartDump', {static: false}) dateRangeStartDump: ElementRef;
  @ViewChild('dateRangeEndDump', {static: false}) dateRangeEndDump: ElementRef;

  constructor(private leadapi:LeadsService,private sharedapi:SharedService,private dialog:MatDialog,public miscapi:MiscService,public router: Router,private userapi:UserService) { }

  ngOnInit(): void
  {
      this.getbds();this.getcircle();this.getLeadSources();this.getBridgeNumberLists();
      this.getleadStatus();this.getTreatment();this.getTreatmentCategory();this.get_pre_salesbds();
      this.sharedapi.getRole().subscribe((item:string) => {this.myrole=item;});
      this.myrole = localStorage.getItem('role');
      this.userId = localStorage.getItem('loginuserId');
      this.s3url = localStorage.getItem('s3url');
      this.isCMAccess = localStorage.getItem('CMAccess');
      //console.log(this.isCMAccess);
      if(this.userId=='5' || this.userId=='16' || this.userId=='45'){
          //console.log('if');
          this.router.navigateByUrl('dashboard');
      }
  }

  showhideNumber(showNumber,index){
      if(showNumber == '1'){
          this.showNumberArray[index] = true;
      }else{
          this.showNumberArray[index] = false;
      }
  }

  ngAfterViewInit() {
       this.loadleads(0,this.perpage);
  }

  resetFilters(){
      this.clearDate();
      this.clearDateFollowUp();
     
      this.search = ''; this.lead_source = '';  this.lead_status = ''; this.bd = ''; this.circle = ''; this.treatment = ''; this.bridgeno = ''; this.lead_category_filter = '';  this.category_filter = ''; this.payment_mode = ''; this.tertiary_city_filter = '';   this.displayInactiveUsersLead = false; this.c2crecording=''; this.showopdDonebutIpdNotDone = ''; this.gender = '';this.pre_sale_users_filter = '';
      this.loadleads(0,25);
  }

  getRefferalType(type){
      let status = 'NA';
      switch(type)
      {
          case 1:
          status = 'Doctor Refferal';
          break;
          case 2:
          status = 'Employee Refferal';
          break;
          case 3:
          status = 'Others Refferal';
          break;
          case 4:
          status = 'Patient Refferal';
          break;
          case 5:
          status = 'PX Refferal';
          break;
          case 6:
          status = 'Diagnostic';
          break;
          case 7:
          status = 'Lab';
          break;
          case 8:
          status = 'Phlebotomist';
          break;
          case 9:
          status = 'City Team';
          break;
          
      }
      return status;
  }

  setSearchValue(type){
      if(type=='lead_status'){
          $("#lead_status_Search").val('');
          $("#lead_status_Search").focus();
          this.leadStatus= this.leadStatus_copy;
      }else if(type=='bds'){
          $("#bd_search").val('');
          $("#bd_search").focus();
          this.bds= this.bds_copy;
      }else if(type=='circle'){
          $("#circleSearch").val('');
          $("#circleSearch").focus();
          this.circles= this.circles_copy;
      }else if(type=='treatment'){
          $("#treatmentSearch").val('');
          $("#treatmentSearch").focus();
          this.treatments= this.treatments_copy;
      }
  }

  searchOnSelect(searchtText: string, type){
      if (type == 'lead_status') {
          this.leadStatus = this.sharedapi.searchData(searchtText, this.leadStatus_copy, "name");
      }else if(type == 'bds'){
          this.bds = this.sharedapi.searchData(searchtText, this.bds_copy, "name");
      }else  if (type == 'circle') {
          this.circles = this.sharedapi.searchData(searchtText, this.circles_copy, "name");
      }else  if (type == 'treatment') {
          this.treatments = this.sharedapi.searchData(searchtText, this.treatments_copy, "name");
      }
  }

  showDuplicateModal(leadid){
      this.LeadId= leadid;
      $('#duplicateModal').modal();
  }

  hideduplicateModal()
  {
      $('#duplicateModal').modal('hide');
  }


  copyLead(){
      this.copyData=true;
      this.leadapi.copyLeadData(this.LeadId).subscribe((data:any) => {
          if(data.status)
          {
              this.copyData=false;
              $('#duplicateModal').modal('hide');
              this.loadleads(0,this.perpage);
          }
      }, error => {
          this.copyData=false;
          this.sharedapi.checkError(error);
      });
  }

    get_pre_salesbds(){
        this.userapi.getpresalesbds().subscribe((data:any) => {
            if(data.status)
            {
                this.allpre_sale_users = data.data;
                
            }else{
                this.allpre_sale_users = [];
            }
        }, error => {
            this.sharedapi.checkError(error);
        });
    }


  async loadleads(pageIndex,perpage)
  {
      /* console.log(this.bd); */
      this.tertiarycityFilter = false;
      if(this.circle.indexOf('8') !== -1){
          this.tertiarycityFilter = true;
      }
      if(this.displayInactiveUsersLead == true) {
        this.getbds(0);
      } else {
        this.getbds();
      }
      this.leads = [];
      this.paginator.pageIndex = pageIndex;
      let qString = "";

      let lead_type = "";
      if(this.router.url == "/partner-leads"){
          lead_type = "partner";
      }

      if(this.router.url == "/gp-leads"){
          let lead_source_gp = '34';
          qString = 'search='+this.search+'&circle='+this.circle+'&treatment='+this.treatment+'&lead_status='+this.lead_status+'&bd='+this.bd+'&lead_source='+lead_source_gp+'&date_range='+this.start_date+'-'+this.end_date+'&ipdopnd='+this.showopdDonebutIpdNotDone+'&bridgeno='+this.bridgeno+'&category_filter='+this.category_filter+'&payment_mode='+this.payment_mode+'&lead_category_filter='+this.lead_category_filter+'&tertiary_city_filter='+this.tertiary_city_filter+'&display_inactive_user_list='+this.displayInactiveUsersLead+'&gender='+this.gender+'&follow_up_date_range='+this.start_date_follow_up+'-'+this.end_date_follow_up;;
          
      } else {
          qString = 'search='+this.search+'&circle='+this.circle+'&treatment='+this.treatment+'&lead_status='+this.lead_status+'&bd='+this.bd+'&lead_source='+this.lead_source+'&date_range='+this.start_date+'-'+this.end_date+'&ipdopnd='+this.showopdDonebutIpdNotDone+'&bridgeno='+this.bridgeno+'&category_filter='+this.category_filter+'&payment_mode='+this.payment_mode+'&lead_category_filter='+this.lead_category_filter+'&tertiary_city_filter='+this.tertiary_city_filter+'&display_inactive_user_list='+this.displayInactiveUsersLead+'&gender='+this.gender+'&follow_up_date_range='+this.start_date_follow_up+'-'+this.end_date_follow_up+'&lead_type='+lead_type+'&c2ckalerarecording='+this.c2ckalerarecording+'&pre_sale_users='+this.pre_sale_users_filter;
      }
      
      if(this.myrole=='14' && this.isCMAccess == '1'){
          this.loadPartnerleads(pageIndex,perpage);
      }


      this.loading = true;this.loaded = false;
      this.leadapi.getLeadsWithCallRecording(this.paginator.pageIndex,perpage,qString).subscribe((data:any) => {
          this.length = parseInt(data.totaldata);
          this.loading = false;
          this.loaded = true;
          if(data.status)
          {
              this.leads = data.data;
          }else{
              this.leads = [];
          }
      }, error => {
          this.loading = false;
          this.loaded = true;
          this.sharedapi.checkError(error);
      });
  }

  pageChange(event)
  {
      this.pageIndex = event.pageIndex;
      this.loadleads(event.pageIndex,event.pageSize);
  }

  public getServerData(event:PageEvent):any
  {
      this.perpage = event.pageSize;
      this.pageIndex = event.pageIndex;
      this.loadleads(event.pageIndex,event.pageSize);
  }

  async getleadStatus()
  {
      this.leadapi.getLeadStatus().subscribe((data:any) => {
          if(data.status)
          {
              this.leadStatus = data.data;
              this.leadStatus_copy = this.leadStatus;
          }else{
              this.leadStatus = [];
          }
      }, error => {
          this.sharedapi.checkError(error);
      });
  }

  async getbds(status=1)
  {
      this.leadapi.getbds(status).subscribe((data:any) => {
          if(data.status)
          {
              this.bds = data.data;
              this.bds_copy = this.bds;
          }else{
              this.bds = [];
          }
      }, error => {
          this.sharedapi.checkError(error);
      });
  }

  async getcircle()
  {
      this.leadapi.getcircles().subscribe((data:any) => {
          if(data.status)
          {
              this.circles = data.data;
              this.circles_copy = this.circles;
          }else{
              this.circles = [];
          }
      }, error => {
          this.sharedapi.checkError(error);
      });
  }

  async getLeadSources()
  {
      this.leadapi.getLeadSources().subscribe((data:any) => {
          if(data.status)
          {
              this.lead_sources = data.data;
          }else{
              this.lead_sources = [];
          }
      }, error => {
          this.sharedapi.checkError(error);
      });
  }
  async getBridgeNumberLists()
  {
      this.leadapi.getBridgeNumberLists().subscribe((data:any) => {
          if(data.status)
          {
              this.bridge_number_lists = data.data;
          }else{
              this.bridge_number_lists = [];
          }
      }, error => {
          this.sharedapi.checkError(error);
      });
  }

  async getTreatment()
  {
      this.leadapi.getTreatments().subscribe((data:any) => {
          if(data.status)
          {
              this.treatments = data.data;
              this.treatments_copy = this.treatments;
          }else{
              this.treatments = [];
          }
      }, error => {
          this.sharedapi.checkError(error);
      });
  }

  async getTreatmentCategory()
  {
      await this.miscapi.getTreat_Category().subscribe((data:any) => {
          if(data.status)
          {
              this.treatCategory = data.data;
          }else{
              this.treatCategory = [];
              this.sharedapi.presentToast(data.msg);
          }
      }, error => {
          this.sharedapi.checkError(error);
      });
  }

  dateRangeChange(date1,date2)
  {
      if(date2.value)
      {
          this.start_date = date1.value;
          this.end_date = date2.value;
          //this.loadleads(0,this.perpage);
      }
  }

  clearDate()
  {
      this.dateRangeStart.nativeElement.value = "";
      this.dateRangeEnd.nativeElement.value = "";
      this.start_date = '';
      this.end_date = '';
      //this.loadleads(0,this.perpage);
  }

  dateRangeChangefollowUp(date1,date2)
  {
      if(date2.value)
      {
          this.start_date_follow_up = date1.value;
          this.end_date_follow_up = date2.value;
          //this.loadleads(0,this.perpage);
      }
  }

  clearDateFollowUp()
  {
      this.followupdateRangeStart.nativeElement.value = "";
      this.followupdateRangeEnd.nativeElement.value = "";
      this.start_date_follow_up = '';
      this.end_date_follow_up = '';
      //this.loadleads(0,this.perpage);
  }

  toJson(json)
  {
      return JSON.parse(json);
  }


  hideModal()
  {
      $('#myModal').modal('hide');
  }

  showModal()
  {
      $('#myModal').modal();
  }

  hideModalFb()
  {
      $('#myModalfb').modal('hide');
  }

  showModalFb()
  {
      $('#myModalfb').modal();
  }

  hideModalPartner()
  {
      $('#myModalpartners').modal('hide');
  }

  showModalPartners()
  {
      $('#myModalpartners').modal();
  }

  hideStatusModal()
  {
      $('#paymentTreatmentModal').modal('hide');
  }

  async selectFileFb(event)
  {
      this.submitted = true;
      let file = event.target.files.item(0);
      const formData = new FormData();
      formData.append('file', file);
      this.leadapi.uploadcsvFb(formData)
      .subscribe((data:any) => {
          this.submitted = false;
          this.csvUploadFb.nativeElement.value = "";
          if(data.status)
          {
              this.hideModalFb();
              this.sharedapi.presentToast(data.msg);
          }
          else
          {
              this.sharedapi.presentToast(data.msg);
          }
        }, error =>
          {
              this.sharedapi.checkError(error);
          });
  }

  async selectFilePartners(event)
  {
      this.submittedPartners = true;
      let file = event.target.files.item(0);
      const formData = new FormData();
      formData.append('file', file);
      this.leadapi.uploadcsvPartners(formData)
      .subscribe((data:any) => {
          this.submittedPartners = false;
          this.csvUploadPartners.nativeElement.value = "";
          if(data.status)
          {
              this.hideModalFb();
              this.sharedapi.presentToast(data.msg);
          }
          else
          {
              this.sharedapi.presentToast(data.msg);
          }
        }, error =>
          {
              this.sharedapi.checkError(error);
          });
  }


  async selectFile(event)
  {
      this.submitted = true;
      let file = event.target.files.item(0);
      const formData = new FormData();
      formData.append('file', file);
      this.leadapi.uploadcsv(formData)
      .subscribe((data:any) => {
          this.submitted = false;
          this.csvUpload.nativeElement.value = "";
          if(data.status)
          {
              this.hideModal();
              this.sharedapi.presentToast(data.msg);
          }
          else
          {
              this.sharedapi.presentToast(data.msg);
          }
        }, error =>
          {
              this.sharedapi.checkError(error);
          });
  }

  openInsuranceDialog(lead_id)
  {
      const dialogRef = this.dialog.open(UpdateInsuranceModalComponent, {
          width: '100%',height: '90%',
          data:{lead_id:lead_id}
      });

      dialogRef.afterClosed().subscribe(result => {
          console.log(result);
      });
  }

  openOpdDialog(lead_id)
  {
      const dialogRef = this.dialog.open(OpdModalComponent, {
          width: '100%',height: '90%',
          data:{lead_id:lead_id}
      });

      dialogRef.afterClosed().subscribe(result => {
          console.log(result);
      });
  }

  openIpdDialog(lead_id)
  {
      const dialogRef = this.dialog.open(IpdModalComponent, {
          width: '100%',height: '90%',
          data:{lead_id:lead_id}
      });

      dialogRef.afterClosed().subscribe(result => {
          console.log(result);
      });
  }

  getSource(Srcstatus)
  {
      let status = 'NA';
      switch(Srcstatus)
      {
          case 1:
          status = 'Forms';
          break;
          case 2:
          status = 'Kaleyra';
          break;
          case 3:
          status = 'Practo';
          break;
          case 4:
          status = 'Consult Now';
          break;
          case 5:
          status = 'FB/IG';
          break;
          case 6:
          status = 'Youtube';
          break;
          case 7:
          status = 'Referral';
          break;
          case 8:
          status = 'Blogs';
          break;


      }
      return status;
  }

  getPaymentTreatmentStatus(leadId,actionType){
      this.leadapi.getpaymenttreatmentStatus(leadId).subscribe((data:any) => {
          if(data.status)
          {
              console.log(data);
              if(actionType=='Upload Insurance Card'){
                  if(data.result.status==true){
                      this.openInsuranceDialog(leadId);
                  }else{
                      $("#paymentTreatmentModal").modal();
                      $("#StatusText").text(data.result.message);
                  }
              }
              else if(actionType=='Post OPD'){
                  if(data.result.status==true){
                      this.openOpdDialog(leadId);
                  }else{
                      $("#paymentTreatmentModal").modal();
                      $("#StatusText").text(data.result.message);
                  }
              }

              else if(actionType=='Post IPD'){
                  if(data.result.status==true){
                      this.openIpdDialog(leadId);
                  }else{
                      $("#paymentTreatmentModal").modal();
                      $("#StatusText").text(data.result.message);
                  }
              }

              else if(actionType=='Create Duplicate Lead'){
                  if(data.result.status==true){
                      this.showDuplicateModal(leadId);
                  }else{
                      $("#paymentTreatmentModal").modal();
                      $("#StatusText").text(data.result.message);
                  }
              }

          }
      })
  }

  async loadPartnerleads(pageIndex,perpage)
  {
      /* console.log(this.bd); */
      this.tertiarycityFilter = false;
      if(this.circle.indexOf('8') !== -1){
          this.tertiarycityFilter = true;
      }
      if(this.displayInactiveUsersLead == true) {
        this.getbds(0);
      } else {
        this.getbds();
      }
      this.partner_leads = [];
      this.paginator.pageIndex = pageIndex;

      let lead_type = "";
      if(this.router.url == "/partner-leads"){
          lead_type = "partner";
      }

      let qString = "";
      if(this.router.url == "/gp-leads"){
          let lead_source_gp = '34';
          qString = 'search='+this.search+'&circle='+this.circle+'&treatment='+this.treatment+'&lead_status='+this.lead_status+'&bd='+this.bd+'&lead_source='+lead_source_gp+'&date_range='+this.start_date+'-'+this.end_date+'&ipdopnd='+this.showopdDonebutIpdNotDone+'&bridgeno='+this.bridgeno+'&category_filter='+this.category_filter+'&payment_mode='+this.payment_mode+'&lead_category_filter='+this.lead_category_filter+'&tertiary_city_filter='+this.tertiary_city_filter+'&display_inactive_user_list='+this.displayInactiveUsersLead+'&gender='+this.gender+'&follow_up_date_range='+this.start_date_follow_up+'-'+this.end_date_follow_up;;
      } else {
          qString = 'search='+this.search+'&circle='+this.circle+'&treatment='+this.treatment+'&lead_status='+this.lead_status+'&bd='+this.bd+'&lead_source='+this.lead_source+'&date_range='+this.start_date+'-'+this.end_date+'&ipdopnd='+this.showopdDonebutIpdNotDone+'&bridgeno='+this.bridgeno+'&category_filter='+this.category_filter+'&payment_mode='+this.payment_mode+'&lead_category_filter='+this.lead_category_filter+'&tertiary_city_filter='+this.tertiary_city_filter+'&display_inactive_user_list='+this.displayInactiveUsersLead+'&gender='+this.gender+'&follow_up_date_range='+this.start_date_follow_up+'-'+this.end_date_follow_up+'&lead_type='+lead_type;
          ;
      }
      


      this.loading = true;this.loaded = false;
      this.leadapi.getPartnerLeads(this.paginator.pageIndex,perpage,qString).subscribe((data:any) => {
          this.length = parseInt(data.totaldata);
          this.loading = false;
          this.loaded = true;
          if(data.status)
          {
              this.partner_leads = data.data;
          }else{
              this.partner_leads = [];
          }
      }, error => {
          this.loading = false;
          this.loaded = true;
          this.sharedapi.checkError(error);
      });
  }



  exportTrainingLeadData()
  {
      if(this.leads.length>0)
      {
          let data = [];
          let titles = [
              'Patient Id','Glamyo Patient Id', 'Lead Source', 'Lead Status', 'Lead Location', 'Circle', 'Lead Owner','Employee Id', 'Treatment', 'Description', 'Lead Time', 'First Action Taken Time' , 'First Action Taken' ,'Surgery Time','Follow-up Date', 'C2C Recording Status', 'C2C Recording Links', 'Kaleyra Recording Links'
          ];


          data.push(titles);
          for(let key in this.leads)
          {

            let kaleyra_recording_arr = [];
            if(this.leads[key].call_details){
                kaleyra_recording_arr = JSON.parse(this.leads[key].call_details)
            }

            let kal_recording_url = '';
            if(kaleyra_recording_arr)
            {
                for(let callD in kaleyra_recording_arr)
                {
                    if(kaleyra_recording_arr[callD].call_recording_url)
                    {
                        kal_recording_url += kaleyra_recording_arr[callD].call_recording_url+'\n';
                    }
                }
            }


              let first_leadAction = this.leads[key].first_leadAction;
              var firstActionTime = '';
              var firstActionText = '';
              if(first_leadAction){
                  let splitActionData = first_leadAction.split('@at@');
                  //console.log(splitActionData);
                  firstActionText = splitActionData[0];
                   firstActionTime = splitActionData[1];
              }


              
              

                var surgery_date =''; var follow_update = ""; var lead_time = "";
                if(this.leads[key].ipd_surgery_date){
                    surgery_date = formatDate(this.leads[key].ipd_surgery_date*1000, 'dd MMM, yyyy hh:mm aa', 'en-US');
                }
                if(this.leads[key].followup_date){
                    follow_update = formatDate(this.leads[key].followup_date*1000, 'dd MMM, yyyy', 'en-US');
                }
                let recording_status = 'No';
                if(this.leads[key].click_to_call_recording)
                {
                    recording_status = 'Yes';
                }

              let LeadTime = formatDate(this.leads[key].lead_time*1000, 'dd/MM/YYYY H:m', 'en-US');
              
              let exdata = [
                  this.leads[key].patient_id,
                  this.leads[key].glamyo_patient_id,
                  this.leads[key].source_name,
                  this.leads[key].lead_status_name,
                  this.leads[key].city_name,
                  this.leads[key].circle_name,
                  this.leads[key].bd_name,
                  this.leads[key].employee_id,
                  this.leads[key].treatment_name,
                  this.leads[key].description,
                  LeadTime,
                  firstActionTime,
                  firstActionText.replace(/<[^>]*>/g, ''),
                  surgery_date,
                  follow_update,
                  recording_status,
                  this.leads[key].click_to_call_recording_only,
                  kal_recording_url
              ];
              data.push(exdata);
          }


          let ws = XLSX.utils.aoa_to_sheet(data);
         /* generate workbook and add the worksheet */
         const wb: XLSX.WorkBook = XLSX.utils.book_new();
         XLSX.utils.book_append_sheet(wb, ws, 'Sheet1');

         /* save to file */
         let utc = new Date().toJSON().slice(0,10).replace(/-/g,'/');
         XLSX.writeFile(wb, 'lead_'+utc+'.xlsx');
      }else{
          this.sharedapi.presentToast('Something went wrong, Try Again!');
      }
  }

  showModalLeadDump()
  {
      $('#leadDumpData').modal('show');
  }
  hideModalLeadDump()
  {
      window.location.reload();
  }

  dateRangeChangeDump(date1,date2)
  {
      if(date2.value)
      {
          this.start_date_dump = date1.value;
          this.end_date_dump = date2.value;
      }
  }

  clearDateDump()
  {
      this.dateRangeStartDump.nativeElement.value = "";
      this.dateRangeEndDump.nativeElement.value = "";
      this.start_date_dump = '';
      this.end_date_dump = '';
  }

  async getleaddumpByDate()
  {
      let qString = 'date_range='+this.start_date_dump+'-'+this.end_date_dump+'&withcc='+this.export_dump_with_c2c+'&kcall='+this.export_dump_with_kalera_call;
      this.dump_loading = true;
      this.paging_html_dump = "";
      this.leadapi.getleaddumpByDate(qString).subscribe((data:any) => {
          this.dump_loading = false;
          if(data.status){
              /* console.log(data.data); */
              this.dump_from_paging=data.data.from;
              if(this.dump_from_paging){
                  this.dump_to_paging=data.data.last_page;
                  this.dump_per_page=data.data.per_page;
                  this.dump_total=data.data.total;
                  this.date_range_dump=data.data.date_range;
                  this.paging_html_dump += '<div class="tableFixHead" style="overflow: scroll">  <table class="table table-striped"><thead><tr class="text-center"><th>#</th><th>Page Number</th><th>Action</th></tr></thead><tbody>';
                  for(let x:number=this.dump_from_paging; x<=this.dump_to_paging; ++x)
                  {
                      let from_text = 1;
                      if(x>1){
                          from_text = Number(((x-1)*this.dump_per_page)+1);
                      }
                      let to_text = Number(this.dump_per_page*x);
                      if(this.dump_to_paging == x){
                          to_text = ((Number(((x-1)*this.dump_per_page)+1) - 1) +(this.dump_per_page - Number(Number(this.dump_per_page*x) - this.dump_total)));
                      }
                      this.paging_html_dump += "<tr class='text-center'><td>"+x+"</td><td>Page "+x+" (From "+from_text+" to "+to_text+")</td><td><a href='"+apiUrlServ+"get-leads-dump-by-date?page="+x+"&"+qString+"' target='_blank'>Download CSV</td></tr>";
                  }
                  this.paging_html_dump += "</tbody><table></div>";
              } else {
                  this.sharedapi.presentToast("No data Found.");
              }
          } else {
              this.sharedapi.presentToast(data.msg);
              this.dump_from_paging=0;
              this.dump_to_paging=0;
              this.dump_per_page=0;
              this.dump_total=0;
              this.paging_html_dump = "";
              this.date_range_dump="";
          }
      }, error => {
          this.dump_loading = false;
          this.sharedapi.checkError(error);
      });
  }

}
